import { getProxiedServiceUrl } from '@xengage/gw-portals-url-js';
import { JsonRPCService } from '@xengage/gw-portals-transport-js';

export default {
    getSigningURL(request) {
        return JsonRPCService.send(getProxiedServiceUrl('signnow'), 'getSigningURL', [request]);
    },

    markFormsAsSigned(request) {
        return JsonRPCService.send(getProxiedServiceUrl('signnow'), 'markFormsAsSigned', [request]);
    },

    getEndorsementSigningURL(request,authHeader) {
        return JsonRPCService.send(getProxiedServiceUrl('signnow'), 'getEndorsementSigningURL', [request],authHeader);
    },

    markEndorsementFormsAsSigned(request,authHeader) {
        return JsonRPCService.send(getProxiedServiceUrl('signnow'), 'markEndorsementFormsAsSigned', [request],authHeader);
    }
};
